module.exports = __webpack_public_path__ + "static/img/13.35883b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/zh/13.png
// module id = gBPU
// module chunks = 0